module.exports = __webpack_public_path__ + "static/media/cost-euro.23e0a258.svg";